/**
 * ---------------------------------------------------------------------------
 * THE SWITCH
 * ---------------------------------------------------------------------------
 * The dashboard talks to either your local backend or production. Change it in
 * ONE place: `REACT_APP_ENV` inside the dashboard `.env` file.
 *
 *   REACT_APP_ENV=local        -> http://127.0.0.1:8000/api
 *   REACT_APP_ENV=production   -> https://thebrokerz.com/api
 *
 * Optional overrides (also in .env):
 *   REACT_APP_API_BASE_URL=http://192.168.1.20:8000/api   (custom backend)
 *   REACT_APP_SIGNATURE_SECRET=...                        (must match the
 *                                                          backend SIGNATURE_SECRET)
 *
 * Note: Create React App only exposes variables prefixed with REACT_APP_, and
 * it reads .env at start time, so restart `npm start` after changing it.
 */

const ENVIRONMENTS = {
    local: {
        apiBaseUrl: "http://127.0.0.1:8000/api",
    },
    production: {
        apiBaseUrl: "https://thebrokerz.com/api",
    },
};

const rawEnvironment = (process.env.REACT_APP_ENV || "local").trim().toLowerCase();

export const ENVIRONMENT = ["production", "prod"].includes(rawEnvironment)
    ? "production"
    : "local";

export const IS_LOCAL = ENVIRONMENT === "local";

export const API_BASE_URL =
    (process.env.REACT_APP_API_BASE_URL || "").trim() ||
    ENVIRONMENTS[ENVIRONMENT].apiBaseUrl;

/**
 * Must match SIGNATURE_SECRET in the backend .env (the local and the production
 * backends currently share the same secret, and it is the same one the mobile
 * app signs its requests with). A wrong value here makes every signed endpoint
 * answer "400 Invalid Signature".
 */
export const SIGNATURE_SECRET =
    (process.env.REACT_APP_SIGNATURE_SECRET || "").trim() ||
    "469e0123d9170f18a13deb7391603cf9d6b2bb788fe0623ad5a1013038918bed";

if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.info(`[brokerz-dashboard] environment: ${ENVIRONMENT} -> ${API_BASE_URL}`);
}
